module.exports = __webpack_public_path__ + "static/AddItem-438c69315b273a7ecef4ca06e19002ab.png";